import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { AppointmentService } from '../services/appointments';

export const useFetchSearchPsychologist = ({
  name,
  insurance = false,
}: {
  name: string;
  insurance?: boolean;
}): UseQueryResult<Psychologist[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PSYCHOLOGISTS_BY_NAME, name, insurance],
    queryFn: () => AppointmentService.getPsychologistsByName({ name, insurance }),
    select: data => data.data,
    enabled: !!name && !!insurance,
  });
